/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AccountEventRequests, AccountEventsResponse } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AccountEvents<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name AccountEventsCreate
   * @request POST:/account-events
   */
  accountEventsCreate = (data: AccountEventRequests, params: RequestParams = {}) =>
    this.request<AccountEventsResponse, any>({
      path: `/account-events`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
